import { Method } from '../../data/DataUtils.js';
import * as DataUtils from '../../data/DataUtils.js';
import * as DTOs from '../DTOs/EstadiosClubesDTOs.js';

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'estadios/' + idPadre + '/clubes/' + idItem,
    null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject('estadios/' + idPadre + '/clubes/' + idItem);
};

export const GetListaItems = async (idPadre) => {
  return DataUtils.FetchLista('estadios/' + idPadre + '/clubes');
};

export const PostItem = async (idPadre, datosItem) => {
  await DataUtils.SaveObject(
    Method.POST,
    'estadios/' + idPadre + '/clubes/' + datosItem.club.id,
    DTOs.saveItem(datosItem)
  );
  // se devuelve el id del club porque el item tiene id compuesto
  return datosItem.club.id;
};

export const PutItem = async (idPadre, datosItem) => {
  await DataUtils.SaveObject(
    Method.PUT,
    'estadios/' + idPadre + '/clubes/' + datosItem.club.id,
    DTOs.saveItem(datosItem)
  );
  // se devuelve el id del club porque el item tiene id compuesto
  return datosItem.club.id;
};
